module.exports = __webpack_public_path__ + "static/media/cssLogo.f334a25c.png";